import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { IServiceToolbarBase, PagedBaseResponse } from 'rte-library';
import { Observable } from 'rxjs';
import { Report } from './models/report.model';
import { environment } from 'src/environments/environment';
import { Provider } from '../provider/provider.model';
import { appendHttpParams } from '../../helpers/http.helper';

@Injectable({
  providedIn: 'root'
})
export class ReportService implements IServiceToolbarBase<Report> {

  //#region Proprieties

  onReportChange: EventEmitter<any> = new EventEmitter<any>();
  headers = new HttpHeaders({
    'No-loading': 'True'
  });

  //#endregion

  //#region Ctor

  constructor(private http: HttpClient) {
  }

  //#endregion

  //#region IServiceToolbarBase methods

  clear(objectCurrent: Report) {
    objectCurrent.Description = '';
    objectCurrent.Entities = [];
    objectCurrent.RelatedEntities = [];
    objectCurrent.Provider = new Provider();
    objectCurrent.Revision = null;
    objectCurrent.Id = null;
    objectCurrent.Name = null;
    objectCurrent.Query = '';
  }

  save(objectCurrent: Report) {
    if (objectCurrent.Id <= 0 || objectCurrent.Id == null) {
      delete objectCurrent.Id;
      delete objectCurrent.Revision;
      return this.http.post(environment.apiUrl + 'api/report', objectCurrent);
    } else {
      objectCurrent.Revision = !objectCurrent.Revision ? 1 : objectCurrent.Revision;
      return this.http.put(environment.apiUrl + 'api/report', objectCurrent);
    }

  }

  publish(objectCurrent: Report) {
    return this.http.post<string>(environment.apiUrl + 'api/report/publish', objectCurrent);
  }

  publishMenuUpdateReport(objectCurrent: Report) {
    return this.http.post<string>(environment.apiUrl + 'api/report/publish',  objectCurrent, { headers: this.headers });
  }

  verifyMenuExists(objectCurrent: Report) {
    return this.http.post<boolean>(environment.apiUrl + 'api/report/verifyMenuExists', objectCurrent);
  }

  delete(objectCurrent: Report): Observable<boolean> {
    let params = new HttpParams();

    params = appendHttpParams('id', objectCurrent.Id, params);

    return this.http.delete<boolean>(environment.apiUrl + 'api/report', {params});
  }

  getBySystem(nameMenu: string) {
    let params = new HttpParams();

    params = appendHttpParams('systemReport', true, params);
    params = appendHttpParams('menuSystem', nameMenu, params);

    return this.http.get<Report[]>(environment.apiUrl + 'api/report/searchBySystem', { params });
  }

  getById(objectCurrent: Report) {
    let params = new HttpParams();

    params = appendHttpParams('page', 1, params);
    params = appendHttpParams('amountByPage', 1, params);
    params = appendHttpParams('id', objectCurrent.Id, params);

    return this.http.get<PagedBaseResponse<Report>>(environment.apiUrl + 'api/report/search', {params});
  }

  get(objectCurrent: Report, page: number, pageSize: number): Observable<PagedBaseResponse<Report>> {
    let params = new HttpParams();
    page++;
    params = appendHttpParams('page', page, params);
    params = appendHttpParams('amountByPage', pageSize, params);
    params = appendHttpParams('Description', objectCurrent.Description, params);
    params = appendHttpParams('Name', objectCurrent.Name, params);

    if (objectCurrent.Provider) {
      params = appendHttpParams('ProviderId', objectCurrent.Provider.Id, params);
    }

    return this.http.get<PagedBaseResponse<Report>>(environment.apiUrl + 'api/report/search', {params});
  }

  //#endregion
}
